import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface FriendsState {
  invitedCount: number;
}

const initialState: FriendsState = {
  invitedCount: 0,
};

const friendsSlice = createSlice({
  name: 'friends',
  initialState,
  reducers: {
    setInvitedCount: (state, action: PayloadAction<number>) => {
      state.invitedCount = action.payload;
    },
    incrementInvitedCount: (state) => {
      state.invitedCount += 1;
    },
    decrementInvitedCount: (state) => {
      state.invitedCount = Math.max(0, state.invitedCount - 1);
    },
    resetInvitedCount: (state) => {
      state.invitedCount = 0;
    },
  },
});

export const { setInvitedCount, incrementInvitedCount, decrementInvitedCount, resetInvitedCount } =
  friendsSlice.actions;
export default friendsSlice.reducer;
